/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 02.06.17.
 */

import React from "react";
import PropTypes from "prop-types";
import _ from "underscore";
import BasePageFrame from "./BasePageFrame";

class Simple extends BasePageFrame {
    static propTypes = {
        params: PropTypes.shape({
            path: PropTypes.string.isRequired,
            resource: PropTypes.string.isRequired,
            action: PropTypes.oneOf(["list","new","view","edit","delete"]).isRequired,
            id: PropTypes.string,
            query: PropTypes.object,
            tab: PropTypes.string,
            parentPath: PropTypes.string,
            parentResource: PropTypes.string,
            parentAction: PropTypes.oneOf(["list","new","view","edit","delete"]),
            parentId: PropTypes.string,
            parentField: PropTypes.string,
            parentTab: PropTypes.string,
            isModal: PropTypes.bool
        }).isRequired,
        location: PropTypes.object.isRequired,
        router: PropTypes.object.isRequired,
        route: PropTypes.object.isRequired,
        options: PropTypes.shape({
            component: PropTypes.string.isRequired,
            schema: PropTypes.string
        }).isRequired
    };

    static defaultProps = {};

    renderBody() {
        let component = this.getPageComponent();
        if (!component) return null;
        return (
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox m-b-sm">
                        {component}
                    </div>
                </div>
            </div>
        );
    }
}

export default Simple;
